/* eslint-disable no-unused-vars */
import React, { useEffect, useState} from "react";
import { Link, useNavigate } from "react-router-dom";
import { Modal, Button } from 'react-bootstrap';
import { Input, List, Avatar, Tag, Divider } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
// import "../../src/assets/js/app";
// import { baricon1, imguser, logo, noteicon, noteicon1, searchnormal, settingicon01, user06 } from './imagepath';
import {
  logo,
  baricon,
  baricon1,
  searchnormal,
  imguser,
  noteicon,
  user06,
  settingicon01,
  calendar,
  noteicon1,
  male,
  female,
  logoname,
  logoOnlyName
} from "./imagepath";
import { DatePicker } from 'antd';
import AppointmentModal from "./appointmentBooking/BookAppointmentPopUp";
import { useAuth } from "../services/authentication_API/authService";
import DoctorSelectPopup from "./appointmentBooking/DoctorSelectPopup";
import { getdoctor } from "../services/doctor/shift schedule/shift_schedule";


const Header = ({refresh}) => {

  const navigate = useNavigate();
  const { logout ,user,userData} = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [step, setStep] = useState("search");
  const [SelectedDoctor, setSelectedDoctor] = useState(null);
  const [showSelectDoctorPopup, setShowSelectDoctorPopup] = useState(false);
      const [doctors, setDoctors] = React.useState([]);   
  


useEffect(() => {
    // Check if the refresh function was actually passed as a prop
   
     if (refresh) { 
      refresh();
    }
    
  }, [showModal]);


  const handleLogout = async (e) => {
    e.preventDefault();

    try {
      await logout();
      navigate("/login"); // Redirect on successful login
    } catch (err) {
     console.log("error while logout")
    } 
  };
      const fetchDoctors = async () => {
        try {
          const result = await getdoctor();
          if (result.success) {
            // Transform the hospital data if needed to fit the table structure
            if(result?.data.length >1){
              setDoctors(result?.data);
              setShowSelectDoctorPopup(true)
            }
            else{
              console.log(result?.data[0])
              setSelectedDoctor(result?.data[0])
              setStep("search");
              setShowModal(true); 
            }
            console.log("Formatted Data:", result.data);
          } else {
            console.error("Error:", result.error || "Failed to fetch hospitals");
          }
        } catch (err) {
          console.error("Exception:", err.message);
        } 
      
      };
      



  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
  };
``
  const handlesidebarmobilemenu = () => {
    console.log("handlesidebarmobilemenu");

    document.body.classList.toggle("slide-nav");
    document.getElementsByTagName("html")[0].classList.add('menu-opened');
    document.getElementsByClassName("sidebar-overlay")[0].classList.toggle("opened");
  };


  const openDrawer = () => {
    const div = document.querySelector(".main-wrapper");
    if (div?.className?.includes("open-msg-box")) {
      div?.classList?.remove("open-msg-box");
    } else {
      div?.classList?.add("open-msg-box");
    }
  };


  useEffect(() => {
    
      document.body.classList.remove("expand-menu");

      document.body.classList.add("mini-sidebar");
    
  }, [user]);
  const handleCancel=() => {
    setShowSelectDoctorPopup(false);
    setSelectedDoctor(null);
  }
  const onselectDoctor = (doctor) => {
    setSelectedDoctor(doctor);
    setShowSelectDoctorPopup(false);
    setStep("search");
    setShowModal(true); 
  }
  

  return (
    <>
      <div className="main-wrapper">
        <div className="header">
          <div className="header-left">
            <Link to="/" className="logo">
              <img src={logo} width={35} height={35} alt="" />{" "}
              <span>
                <img
                  src={logoOnlyName}
                  alt="Logo"
                  style={{
                    maxWidth: "100px",
                    maxHeight: "35px",
                    width: "auto",
                    height: "auto",
                  }}
                />{" "}
              </span>
            </Link>
          </div>
          <Link id="toggle_btn" to="#" onClick={handlesidebar}>
            <img src={baricon} alt="" />
          </Link>
          <Link
            id="mobile_btn"
            className="mobile_btn float-start"
            to="#"
            onClick={handlesidebarmobilemenu}
          >
            <img src={baricon1} alt="" />
          </Link>

          <ul className="nav user-menu d-flex align-items-center flex-wrap justify-content-end">
            {(user == "superadmin" ||
              user == "doctor" ||
              user == "receptionist") && (
              <>
                {user == "receptionist" && (
                  <>
                    <li
                      className="nav-item top-nav-date-picker1"
                      style={{ borderRadius: "8px" }}
                    >
                      <Link
                        to="/book-appoitment"
                        className="nav-link user-link "
                        style={{
                          background: "rgba(46, 55, 164, 0.05)",
                          color: "#2e37a4",
                          // border: "1px solid #007bff",
                          display: "flex",
                          alignItems: "center",
                          padding: "10px 12px 10px",
                          borderRadius: "15px",
                          fontWeight: "500",
                          height: "45px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <img
                          src={calendar}
                          alt="Calendar"
                          style={{
                            width: "18px",
                            height: "18px",
                            marginRight: "6px",
                          }}
                        />
                        Book Appointment
                      </Link>
                    </li>
                    <li
                      className="nav-item top-nav-date-picker1"
                      style={{ borderRadius: "8px" }}
                    >
                      <Link
                        onClick={(e) => {
                          e.preventDefault();
                          // setShowModal(true), setStep("search");
                          fetchDoctors()
                        }}
                        className="nav-link user-link "
                        style={{
                          background: "rgba(46, 55, 164, 0.05)",
                          color: "#2e37a4",
                          // border: "1px solid #007bff",
                          display: "flex",
                          alignItems: "center",
                          padding: "10px 12px 10px",
                          borderRadius: "15px",
                          fontWeight: "500",
                          height: "45px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <img
                          src={calendar}
                          alt="Calendar"
                          style={{
                            width: "18px",
                            height: "18px",
                            marginRight: "6px",
                          }}
                        />
                        Walk-IN
                      </Link>
                    </li>
                  </>
                )}
                {userData && userData?.role && userData?.role?.length > 0 && (
                  <li className="nav-item dropdown has-arrow user-profile-list">
                    <Link
                      to="#"
                      className="dropdown-toggle nav-link user-link"
                      data-bs-toggle="dropdown"
                    >
                      <div className="user-names">
                        <h5>
                          {userData.name} {userData.last_name}
                        </h5>
                        <span>{userData.role[0].name}</span>
                      </div>
                      <span className="user-img">
                        <img
                          src={userData.gender === "male" ? male : female}
                          alt="Admin"
                        />
                      </span>
                    </Link>
                    <div className="dropdown-menu">
                      {user !== "superadmin" &&
                        <Link
                        className="dropdown-item"
                        to={
                          user === "doctor"
                            ? "/doctor-profile"
                            : "/receptionist-profile"
                        }
                      >
                        My Profile
                      </Link>
                      }
                      <Link
                        className="dropdown-item"
                        to="/login"
                        onClick={handleLogout}
                      >
                        Logout
                      </Link>
                    </div>
                  </li>
                )}
              </>
            )}
            {showModal && (
              <AppointmentModal
                showModal={showModal}
                setShowModal={setShowModal}
                doctor={SelectedDoctor}
                step={step}
                setStep={setStep}
                booking_type={"walkin"}
              />
            )}
            {showSelectDoctorPopup && (
              <DoctorSelectPopup
              doctorList={doctors}
                showModal={showSelectDoctorPopup}
                handleCancel={handleCancel}
                setSelectedDoctor={onselectDoctor}
              />
            )}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Header;

Header.propTypes = {
  refresh: PropTypes.func,
 
};